import { createServerFn } from '@tanstack/react-start';
import { defineQuery } from 'groq';

import type { PrivacyPolicyQueryResult } from '@/sanity.types';

import { createSanityClient } from './client';
import { legalDocumentProjection } from './legal-document';

export type PrivacyPolicy = NonNullable<PrivacyPolicyQueryResult>;

const privacyPolicyQuery = defineQuery(`*[
  _type == "privacyPolicy" &&
  _id == "privacyPolicy"
][0] ${legalDocumentProjection}`);

/** Public server function: it only reads the published privacy policy from Sanity. */
export const getPrivacyPolicy = createServerFn({ method: 'GET' }).handler(
  async (): Promise<PrivacyPolicy | null> => {
    const client = createSanityClient();

    try {
      return await client.fetch(privacyPolicyQuery);
    } catch (error) {
      console.error('Failed to load Sanity privacy policy', error);
      return null;
    }
  },
);
